import {TableauView} from '@/helpers/tableau';
import {AnalyticsWrapper} from '@/components/pages/analytics/AnalyticsPage.styles';
import TabsComponent from '@common/TabsComponent';
import Report from '@/components/pages/analytics/Report';
import IncompleteAdmissionCRFsReport from '@/components/pages/analytics/IncompleteAdmissionCRFsReport';
import AdmissionDischargeCRFsReport from '@/components/pages/analytics/AdmissionDischargeCRFsReport';

export default function AnalyticsPage() {
  return (
    <AnalyticsWrapper>
      <TabsComponent
        tabs={[
          // Temporarily removed until events report is fixed in Tableau
          //
          // {
          //   value: 0,
          //   label: 'Events',
          //   route: '/analytics/events',
          //   content: <Report view={TableauView.EVENTS} />,
          // },
          {
            value: 0,
            label: 'Justice Involved',
            route: '/analytics/justice_involved',
            content: <Report view={TableauView.JUSTICE_INVOLVED} />,
          },
          {
            value: 1,
            label: 'End User',
            route: '/analytics/end_user',
            content: <Report view={TableauView.END_USER} />,
          },
          {
            value: 2,
            label: 'Admission Report',
            route: '/analytics/admission_crfs',
            content: <IncompleteAdmissionCRFsReport />,
          },
          {
            value: 3,
            label: 'Incomplete CRFs',
            route: '/analytics/admission_discharge_crfs',
            content: <AdmissionDischargeCRFsReport />,
          },
        ]}
      />
    </AnalyticsWrapper>
  );
}
